import { Box } from '@mui/material';

import { translate } from '@/ui/i18n';
import { ImpactForm } from '@/ui/pages/app/components/quiz-panel/co2/ImpactForm';

import { QuizPanelHideCompletedCheckBox } from '../QuizPanelHideCompletedCheckBox';
import { Co2QuizFormData } from './Co2QuizFormData';
import { QuizFormSeparator } from './components/QuizFormSeparator';

export function Co2QuizMyAnswers({
  projectId,
  form,
}: {
  projectId: number;
  form: Co2QuizFormData;
}) {
  return (
    <Box>
      <QuizPanelHideCompletedCheckBox />
      {form.sections.map((section) => (
        <Box
          key={section.sectionKey}
          id={`${section.sectionKey.toLowerCase()}-form`}
        >
          <QuizFormSeparator
            label={translate(`Co2.Sections.${section.sectionKey}`)}
          />
          {section.questions.map((category) => (
            <ImpactForm
              key={category}
              projectId={projectId}
              sector={form.sector}
              category={category}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
}
